import { render, staticRenderFns } from "./GuestBookingLinks.vue?vue&type=template&id=2a4e1e28"
import script from "./GuestBookingLinks.vue?vue&type=script&lang=js"
export * from "./GuestBookingLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports